import type { DeploymentFreezeFilterQueryParameters, DeploymentFreezeOverviewBffResponse, Repository } from "@octopusdeploy/octopus-server-client";
import { DeploymentFreezesEmptyState } from "~/areas/configuration/components/DeploymentFreezes/DeploymentFreezesEmptyState";
import DeploymentFreezesPage from "~/areas/configuration/components/DeploymentFreezes/DeploymentFreezesPage";
import { isLicensedFeatureAvailable } from "~/components/LicensedFeature/LicensedFeatureContext";
export interface DeploymentFreezesLandingPageLoaderData extends DeploymentFreezeOverviewBffResponse {
    globalDeploymentFreezeEnabled: boolean;
    isTrial: boolean;
}
export interface DeploymentFreezesLandingPageProps {
    loaderData: DeploymentFreezesLandingPageLoaderData;
}
const LandingPageDefaultFilter = {
    Environments: [],
    Projects: [],
    Tenants: [],
    Name: "",
    Status: [],
    PageSize: 30,
    PageNumber: 0,
};
export async function deploymentFreezesLandingPageLoader(repository: Repository): Promise<DeploymentFreezesLandingPageLoaderData> {
    const queryParams: DeploymentFreezeFilterQueryParameters = {
        filterByEnvironments: LandingPageDefaultFilter.Environments,
        filterByName: LandingPageDefaultFilter.Name,
        filterByProjects: LandingPageDefaultFilter.Projects,
        filterByTenants: LandingPageDefaultFilter.Tenants,
        filterByStatus: LandingPageDefaultFilter.Status,
        pageSize: LandingPageDefaultFilter.PageSize.toString(),
        pageNumber: (LandingPageDefaultFilter.PageNumber + 1).toString(),
    };
    const licenseStatus = repository.Licenses.getCurrentStatus();
    const deploymentFreezes = await repository.DeploymentFreezes.getOverviewBff(queryParams);
    return {
        DeploymentFreezes: deploymentFreezes.DeploymentFreezes,
        TotalDeploymentFreezeCount: deploymentFreezes.TotalDeploymentFreezeCount,
        FilteredDeploymentFreezeCount: deploymentFreezes.FilteredDeploymentFreezeCount,
        Filters: deploymentFreezes.Filters,
        globalDeploymentFreezeEnabled: await isLicensedFeatureAvailable("GlobalDeploymentFreeze"),
        isTrial: (await licenseStatus).IsTrial,
    };
}
export function DeploymentFreezesLandingPage({ loaderData }: DeploymentFreezesLandingPageProps) {
    if (!loaderData.TotalDeploymentFreezeCount) {
        return <DeploymentFreezesEmptyState globalDeploymentFreezeEnabled={loaderData.globalDeploymentFreezeEnabled} isTrial={loaderData.isTrial}/>;
    }
    return (<DeploymentFreezesPage initialData={{
            Items: loaderData.DeploymentFreezes,
            ItemsPerPage: LandingPageDefaultFilter.PageSize,
            TotalResults: loaderData.TotalDeploymentFreezeCount,
        }} globalDeploymentFreezeEnabled={loaderData.globalDeploymentFreezeEnabled} isTrial={loaderData.isTrial}/>);
}
